/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { Image } from './model/image';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y
  ? 1
  : 2
  ? A
  : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailImagesCreate = (
  opk: string,
  image: NonReadonly<Image>,
  signal?: AbortSignal
) => {
  return HTTP<Image>({
    url: `/api/v7/people/${opk}/images/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: image,
    signal,
  });
};

export const getApiPersonDetailImagesCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonDetailImagesCreate>>,
    TError,
    { opk: string; data: NonReadonly<Image> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiPersonDetailImagesCreate>>,
  TError,
  { opk: string; data: NonReadonly<Image> },
  TContext
> => {
  const mutationKey = ['apiPersonDetailImagesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonDetailImagesCreate>>,
    { opk: string; data: NonReadonly<Image> }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonDetailImagesCreate(opk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiPersonDetailImagesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailImagesCreate>>
>;
export type ApiPersonDetailImagesCreateMutationBody = NonReadonly<Image>;
export type ApiPersonDetailImagesCreateMutationError = ErrorType<unknown>;

export const useApiPersonDetailImagesCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonDetailImagesCreate>>,
    TError,
    { opk: string; data: NonReadonly<Image> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiPersonDetailImagesCreate>>,
  TError,
  { opk: string; data: NonReadonly<Image> },
  TContext
> => {
  const mutationOptions = getApiPersonDetailImagesCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
